module.exports = __webpack_public_path__ + "img/defaultProfileImage_v2.72a22b83.png";